export default __webpack_public_path__ + "static/media/sponsor_ca_primary.58c96ea8.png";